import React, { useEffect, useState } from "react";
import Preloader from "../../Components/Preloader";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { NavLink } from "react-router-dom";
import AOS from "aos";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import Home_Seo from "../../SEO/Home_Seo";
function DownloadIfepayApp() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 650,    
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <Home_Seo />
          <Header />
          {/* Start Page Banner Area */}
          <div
            className="page-banner-area position-relative overflow-hidden"
            style={{
              backgroundImage: "url(assets/images/hero/hero-image-2.svg)",
            }}
          >
            <div className="container">
              <div className="page-banner-content">
                <h1>Download Ifepay App</h1>
                <ul>
                  <li>
                    <NavLink to="/">Home</NavLink>
                  </li>
                  <li>Download App</li>
                </ul>
              </div>
            </div>
          </div>
          {/* End Page Banner Area */}

          
          {/* Start App Area */}
          <div className="app-area two pb-100 overflow-hidden mt-5">
            <div className="container">
              <div className="download-area bg-color-edf1ee radius-30">
                <div className="row g-4 align-items-center">
                  <div className="col-lg-6 col-md-12" data-aos-delay={200}>
                    <div className="app-image">
                      <img
                        className="radius-30"
                        src="assets/images/app/app-image-5.webp"
                        alt="image"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12" data-aos-delay={200}>
                    <div className="section-heading mb-0 ms-auto">
                      <span className="sub-title two bg-color-9edd05 rounded-pill">
                        Download App
                      </span>
                      <h2>Download And Enjoy The Experience</h2>
                      <p className="mb-5">
                        Send money worldwide in seconds with Ifepay app. Enjoy
                        fast transfers, competitive rates, and secure
                        transactions. Track your transfers easily, and all from
                        a user-friendly app.
                      </p>
                      <div className="app-btn">
                        <NavLink
                          to="https://play.google.com/store/apps/details?id=com.remit.IfePay"
                          target="_blank"
                          className="me-3"
                        >
                          <img
                            className="rounded-3"
                            src="assets/images/app/android.png"
                            alt="image"
                          />
                        </NavLink>
                        <NavLink
                          to="https://apps.apple.com/us/app/ifepay/id6744351163"
                          target="_blank"
                        >
                          <img
                            className="rounded-3"
                            src="assets/images/app/apple.png"
                            alt="image"
                          />
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End App Area */}

          {/* Footer Section Here */}
          <Footer />
        </>
      )}
    </>
  );
}

export default DownloadIfepayApp;
